import { EmailValidity, EmailValidityLabels } from 'models/contacts'
import { colors } from 'styles/tokens'
import { TextPill } from './TextPill'

// DS2026 badge color per validity state — [background, text] from the
// `ds2026-badge-*` tokens (subtle light bg + colored text), matching the rest
// of the DS2026 pills.
const badge = (name: string): [string, string] => [
  colors[`ds2026-badge-${name}-bg`],
  colors[`ds2026-badge-${name}-text`],
]

const VALIDITY_BADGE: Record<EmailValidity, [string, string]> = {
  [EmailValidity.VALID]: badge('success'), // green
  [EmailValidity.INVALID]: badge('error'), // red
  [EmailValidity.ABUSE]: badge('error'), // red
  [EmailValidity.CATCH_ALL]: badge('warning'), // amber
  [EmailValidity.SPAMTRAP]: badge('rose'), // rose — kept distinct from amber/red
  [EmailValidity.DO_NOT_MAIL]: badge('purple'), // purple
  [EmailValidity.UNKNOWN]: badge('gray'), // gray
}

export default function getEmailValidityColors(emailValidity: EmailValidity) {
  return VALIDITY_BADGE[emailValidity]
}

export function EmailValidityPill({
  emailValidity,
}: {
  emailValidity: EmailValidity
}) {
  const [backgroundColor, textColor] = VALIDITY_BADGE[emailValidity]

  return (
    <TextPill
      style={{
        marginBottom: 2,
      }}
      textColor={textColor}
      backgroundColor={backgroundColor}
    >
      {EmailValidityLabels[emailValidity]}
    </TextPill>
  )
}
